import { render } from "./BCardBody.vue?vue&type=template&id=161cc319&ts=true"
import script from "./BCardBody.vue?vue&type=script&lang=ts"
export * from "./BCardBody.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__